import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDatabase } from '../../../providers/database_provider'
import {
    newProject,
    putProject,
    getProjects,
} from '../../../utilities/database_utils'

const DefaultProjectRedirect: React.FC = () => {
    const navigate = useNavigate()
    const db = useDatabase()

    useEffect(() => {
        const setupDefaultProject = async () => {
            try {
                // Check if default project already exists
                const projects = await getProjects(db)
                const defaultProject = projects.find(
                    p => p.metadata_.doc_name === 'Default',
                )
                if (defaultProject) {
                    // Redirect to existing default project
                    navigate(
                        `/app/${defaultProject._id}/residential_field_study_workflow`,
                    )
                    return
                } else {
                    // Create a new default project
                    const project = newProject('Default')
                    const savedProject = await putProject(db, project)
                    navigate(
                        `/app/${savedProject.id}/residential_field_study_workflow`,
                    )
                }
            } catch (error) {
                console.error('Error setting up default project:', error)
                navigate('/projects')
            }
        }

        setupDefaultProject()
    })

    return <div>Loading project...</div>
}

export default DefaultProjectRedirect
